import { render, staticRenderFns } from "./CaseMedicationEffectChain.vue?vue&type=template&id=63ae3247&scoped=true&"
import script from "./CaseMedicationEffectChain.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationEffectChain.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationEffectChain.vue?vue&type=style&index=0&id=63ae3247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae3247",
  null
  
)

export default component.exports